import { useLocation } from 'react-router-dom';

import { usePageContext } from '@/context/PageContext';

export function usePageModal() {
  const location = useLocation();

  const { activePage } = usePageContext();

  // The page will be rendered as a modal if the page has the `modal` property set to true and the location state has a `backgroundLocation` property
  const isPageRenderedAsModal = activePage?.modal && !!location.state?.backgroundLocation;

  // When the modal is closed, we navigate back to the background page location and set the location state to indicate that the previous route was a modal
  const isPreviousLocationModal = !!location.state?.fromModal;

  return {
    isPageRenderedAsModal,
    isPreviousLocationModal
  };
}
